import { customAxios } from './customAxios'
export function getRichiesteSupporto(idPratica) {
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const uri =
    process.env.REACT_APP_BACKEND_HOST +
    `/` +
    process.env.REACT_APP_PATH_NEW_PREFIX +
    `/richiesta/supporto/get/by/adeguataverifica/` +
    idPratica
  const getRichiesteSupportoRequest = customAxios
    .get(uri, config)
    .then(response => response.data.body)
    .catch(err => console.log(err))
  return getRichiesteSupportoRequest
}
